/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Brand_Enum =
  /** G20 */
  | 'G20'
  /** Auchan Hyper */
  | 'auchan_hyper'
  /** Auchan MyAuchan */
  | 'auchan_myauchan'
  /** Auchan Super */
  | 'auchan_super'
  /** Biocoop */
  | 'biocoop'
  /** Carrefour City */
  | 'carrefour_city'
  /** Carrefour Contact */
  | 'carrefour_contact'
  /** Carrefour Express */
  | 'carrefour_express'
  /** Carrefour Hyper */
  | 'carrefour_hyper'
  /** Carrefour Market */
  | 'carrefour_market'
  /** Coccimarket */
  | 'coccimarket'
  /** Coccimarket City */
  | 'coccimarket_city'
  /** Coccimarket Easy */
  | 'coccimarket_easy'
  /** Cora */
  | 'cora'
  /** Diago */
  | 'diago'
  /** E.Leclerc */
  | 'e_leclerc'
  /** E.Leclerc Express */
  | 'e_leclerc_express'
  /** Franprix */
  | 'franprix'
  /** Hyper U */
  | 'hyper_u'
  /** Intermarché Contact */
  | 'intermarche_contact'
  /** Intermarché Express */
  | 'intermarche_express'
  /** Intermarché Hyper */
  | 'intermarche_hyper'
  /** Intermarché Super */
  | 'intermarche_super'
  /** Monop’ */
  | 'monop'
  /** Monoprix */
  | 'monoprix'
  /** Netto */
  | 'netto'
  /** Sitis Market */
  | 'sitis_market'
  /** Spar */
  | 'spar'
  /** Super U */
  | 'super_u'
  /** U Express */
  | 'u_express'
  /** Utile */
  | 'utile';

export type CustomPriceListsByCompanyIdQueryVariables = Exact<{
  companyId: string;
}>;


export type CustomPriceListsByCompanyIdQuery = { custom_price_list: Array<{ id: string, name: string, company_id: string, custom_price_list_packagings: Array<{ discount: number, id: string, packaging_sku: number }>, contracts: Array<{ reference_id: string, buying_company: { tradeName: string, brand: Types.Brand_Enum | null } }> }>, packaging_aggregate: { aggregate: { count: number } | null } };


export const CustomPriceListsByCompanyIdDocument = /*#__PURE__*/ gql`
    query CustomPriceListsByCompanyId($companyId: uuid!) {
  custom_price_list(where: {company_id: {_eq: $companyId}}, order_by: {name: asc}) {
    id
    name
    company_id
    custom_price_list_packagings {
      discount
      id
      packaging_sku
    }
    contracts(
      where: {status: {_eq: SIGNED}}
      order_by: {buying_company: {tradeName: asc}}
    ) {
      buying_company {
        tradeName
        brand
      }
      reference_id
    }
  }
  packaging_aggregate(where: {company_id: {_eq: $companyId}}, limit: 1) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useCustomPriceListsByCompanyIdQuery__
 *
 * To run a query within a React component, call `useCustomPriceListsByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomPriceListsByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomPriceListsByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCustomPriceListsByCompanyIdQuery(baseOptions: Apollo.QueryHookOptions<CustomPriceListsByCompanyIdQuery, CustomPriceListsByCompanyIdQueryVariables> & ({ variables: CustomPriceListsByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomPriceListsByCompanyIdQuery, CustomPriceListsByCompanyIdQueryVariables>(CustomPriceListsByCompanyIdDocument, options);
      }
export function useCustomPriceListsByCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomPriceListsByCompanyIdQuery, CustomPriceListsByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomPriceListsByCompanyIdQuery, CustomPriceListsByCompanyIdQueryVariables>(CustomPriceListsByCompanyIdDocument, options);
        }
// @ts-ignore
export function useCustomPriceListsByCompanyIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomPriceListsByCompanyIdQuery, CustomPriceListsByCompanyIdQueryVariables>): Apollo.UseSuspenseQueryResult<CustomPriceListsByCompanyIdQuery, CustomPriceListsByCompanyIdQueryVariables>;
export function useCustomPriceListsByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomPriceListsByCompanyIdQuery, CustomPriceListsByCompanyIdQueryVariables>): Apollo.UseSuspenseQueryResult<CustomPriceListsByCompanyIdQuery | undefined, CustomPriceListsByCompanyIdQueryVariables>;
export function useCustomPriceListsByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomPriceListsByCompanyIdQuery, CustomPriceListsByCompanyIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomPriceListsByCompanyIdQuery, CustomPriceListsByCompanyIdQueryVariables>(CustomPriceListsByCompanyIdDocument, options);
        }
export type CustomPriceListsByCompanyIdQueryHookResult = ReturnType<typeof useCustomPriceListsByCompanyIdQuery>;
export type CustomPriceListsByCompanyIdLazyQueryHookResult = ReturnType<typeof useCustomPriceListsByCompanyIdLazyQuery>;
export type CustomPriceListsByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useCustomPriceListsByCompanyIdSuspenseQuery>;
export type CustomPriceListsByCompanyIdQueryResult = Apollo.QueryResult<CustomPriceListsByCompanyIdQuery, CustomPriceListsByCompanyIdQueryVariables>;